<template>
  <div class="bone" id="zaim">
    <div class="sec_3 alignPDL">
      <h2>Как быстро получить заём?</h2>
      <div>
        <div>
          <div>
            <img alt="" class="pic konvert" src="img/konvert.webp" />
          </div>
          <div>
            <h3>Отправьте заявку.</h3>
            <p>Заполните заявку и укажите ваши данные для отправки денег</p>
          </div>
        </div>
        <div>
          <div>
            <img alt=""  class="pic clock" src="img/clock.webp" />
          </div>
          <div>
            <h3>Дождитесь рассмотрения.</h3>
            <p>Одобрение займет не более 2 минут</p>
          </div>
        </div>
        <div>
          <div>
            <img alt="" class="pic money"  src="img/money.webp" />
          </div>
          <div>
            <h3>Получите деньги.</h3>
            <p>Сразу же после одобрения мы<br> отправим вам деньги на карту</p>
          </div>
        </div>
        <div>
          <div>
            <img alt="" class="pic logoBox" src="img/finmall_box_logo.svg" />
          </div>
          <div>
            <h3>Установите приложение.</h3>
            <p>В приложении вам доступна вся информация по займу, а так же моментальное погашение</p>
          </div>
        </div>

<!--        <div class="pcOnly">-->
<!--          <img class="pic" src="img/img_6_1.png" />-->
<!--          <div>-->
<!--            <h3>Подпишите документы.</h3>-->
<!--            <p>Подпишите документы онлайн электронной подписью</p>-->
<!--          </div>-->
<!--        </div>-->
        <div>
          <div>
            <img alt="" class="pic pcOnly callGirl" src="img/call_girl.webp" />
          </div>
          <div>
            <h3>Мы всегда на связи.</h3>
            <p>Если у вас есть вопросы - наша служба поддержки всегда на связи, по телефону или в чате</p>
          </div>
        </div>
      </div>
      <button class="dv_mobile mobileOnly" v-on:click="navigationEmit('zform', $event)">Получить деньги</button>
    </div>
    <div class="howToBlockBabe mobileOnly"></div>
  </div>
</template>

<script>
export default {
  name: "uiHowTo",
  methods: {
    navigationEmit(id, event) {
      let scrollData = {}
      scrollData['id'] = id
      scrollData['event'] = event
      this.$emit ('scrollingTo', scrollData )
    },
  }
}
</script>

<style scoped>
h2 { font-family: 'Lato-Heavy'; font-size: 5.29vw }
.bone { background-color: #f3f4f6 ; position: relative; padding: 3.82vw 8.53vw 0;   }
.pic { display: none }
.howToBlockBabe { background-image: url(../../../public/img/img_8_1.png); background-position-x: 100%; background-position-y: 100%; background-repeat: no-repeat; position: absolute; bottom: 0; right: 0; width: 54.71vw; height: 66.06vw; z-index: 10; background-size: 68vw}
.sec_3 { padding: 6.93vw 0 }
.sec_3 > button { margin: 13.18vw 0 16.18vw 0; padding: 4.27vw 6.93vw; border-radius: 15px; height: 14.71vw; width: 52.35vw }
.sec_3 > h2 { padding-bottom: 3.47vw }
.sec_3 > div { padding-left: 6.93vw; position: relative; counter-reset: step 0 }
.sec_3 > div:before { content: ""; display: block; width: 5.60vw; height: 75%; position: absolute; left: 1.87vw; top: 6.93vw; border-left: 2px dashed #1a5b43; }
.sec_3 > div > div > div {  }
.sec_3 > div > div { padding-bottom: 4.27vw}
.sec_3 > div > div > div > h3 { color: #0d5740; margin-right: 1.33vw; font-family: 'Lato-Bold' }
.sec_3 > div > div > div > p { display: inline; line-height: 5.60vw; color: #5B5C5C; }
.sec_3 > div > div:before { counter-increment: step 1; content: counter(step); width: 5.60vw; height: 5.60vw; background: #fff; border-radius: 6.93vw; border: 1px solid #e9efed; line-height: 5.60vw; padding-left: 0; padding-right: 0; color: #1a5b43; display: block; position: absolute; left: -0.83vw; font-weight: 700; text-align: center; }
@media (min-width: 760px) {
  .bone { padding: 0; ; background-image: url(../../../public/img/Free-iPhone-Xs-Max-in-Female-Hand-Mockup-PSD_1.webp); background-size: contain;background-repeat: no-repeat; background-position-x: 112%; }
  .pic { display: block; border-bottom: 4px solid rgba(26, 91, 67, 1); margin-bottom: 1.61vw; height: 8.06vw }
  .sec_3 { padding: 5.81vw 0 7.58vw 0 }
  .sec_3 > h2 { font-size: 2.58vw }
  .sec_3 > div { display: flex; flex-wrap: wrap; width: 58vw; align-items: center; padding-left: 0 }
  .sec_3 > div:before { display: none;}
  .sec_3 > div > div:before { display: none }
  .sec_3 > div > div { width: 21.94vw; margin-right: 2.42vw; height: 15.89vw }
  .sec_3 > div > div > div > h3 { display: block; margin-bottom: 0.65vw; font-size: 1.45vw }
  .sec_3 > div > div > div > p { display: block; line-height: 150% }
  .konvert { aspect-ratio: 119/88 }
  .clock { aspect-ratio: 86/101 }
  .money { aspect-ratio: 174/102 }
  .callGirl { aspect-ratio: 124/101 }
  .logoBox { aspect-ratio: 120/87 }
}
@media (min-width: 1240px) {
  .bone { padding: 0; background-position: center right }
  .pic { border-bottom: 4px solid rgba(26, 91, 67, 1); margin-bottom: 18px; height: 100px }
  .sec_3 { padding: 72px 0 94px 0 }
  .sec_3 > h2 { padding-bottom: 26px; font-size: 32px }
  .sec_3 > div { width: auto; padding-left: 0 }
  .sec_3 > div:before {}
  .sec_3 > div > div:before {  }
  .sec_3 > div > div { width: 272px; margin-right: 30px; padding-bottom: 43px; height: 197px }
  .sec_3 > div > div > div > h3 { margin-bottom: 8px; font-size: 18px }
  .sec_3 > div > div > div > p { line-height: 150% }
  /*.konvert { width: 135px }*/
  /*.clock { width: 85px }*/
  /*.money { width: 170px }*/
  /*.callGirl { width: 138px }*/
  /*.logoBox { width: 122px }*/

}
</style>